import { StoreProductField } from 'app/models/types/store/product';
import { ProductsId } from 'app/models/types';

/**
 * Given an object with product types, returns a summary object.
 */
export const getProductsSummary = (productTypes: StoreProductField['types']) => {
    const pieces: { [key in ProductsId]?: number} = {};

    (Object.keys(productTypes) as ProductsId[]).forEach((type) => {
        if (productTypes[type].selectedAmount > 0 || type === 'bike_slot') {
            pieces[type] = productTypes[type].selectedAmount;
        }
    });

    return pieces;
};
